import { useTranslation } from 'react-i18next';
import { Typography, Box, Avatar, Grid2 as Grid, Link } from '@mui/material';
import {
    Person as PersonIcon, AlternateEmail as AlternateEmailIcon, PhoneAndroid as SmartphoneIcon
} from '@mui/icons-material';
import { getGenderName } from '@utils/helpers';
import ContactExtra from '@components/contact/ContactExtra';

const ContactCard = ({ contact, children }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, padding: 2 }}>

            <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>
                <PersonIcon sx={{ fontSize: 40 }} />
            </Avatar>

            <Box>
                <Typography variant="h1">
                    {getGenderName(t, contact.gender)} {contact.first_name} {contact.last_name}
                </Typography>
                <Grid container alignItems="center">

                    <Grid size={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <AlternateEmailIcon fontSize="small" color="action" />
                        <Link href={`mailto:${contact.email}`} underline="hover" color="inherit" style={{ marginLeft: 8 }}>
                            {contact.email}
                        </Link>
                    </Grid>

                    <Grid size={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <SmartphoneIcon fontSize="small" color="action" />
                        <Link href={`tel:${contact.phone}`} underline="hover" color="inherit" style={{ marginLeft: 8 }}>
                            {contact.phone}
                        </Link>
                    </Grid>

                </Grid>

                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    {t('Language')} : {contact.lang ? t(`lang.${contact.lang}`) : t('Not specified')}
                </Typography>
                <ContactExtra extra={contact.extra} />

            </Box>

            {children && <Box sx={{ flexGrow: 1, textAlign: 'right' }}>
                {children}
            </Box>}
        </Box>
    );
};

export default ContactCard;
